import { createAsyncThunk } from '@reduxjs/toolkit';

import { refreshCatalogSearchResults } from 'entities/CatalogItem';
import { SearchVersionPreference } from 'shared/const/searchVersionPreference';
import { writeSearchVersionPreferenceToStorage } from 'shared/lib/searchVersionPreference/searchVersionPreferenceStorage';

import { searchVersionPreferenceActions } from '../../slice/SearchVersionPreferenceSlice';

import type { ThunkConfig } from 'app/providers/StoreProvider/config/types';

export const setSearchVersionPreference = createAsyncThunk<
    SearchVersionPreference,
    SearchVersionPreference,
    ThunkConfig<string>
>(
    'searchVersionPreference/setSearchVersionPreference',
    async (preference, thunkApi) => {
        const { dispatch } = thunkApi;

        writeSearchVersionPreferenceToStorage(preference);
        dispatch(searchVersionPreferenceActions.setPreference(preference));
        await dispatch(refreshCatalogSearchResults());

        return preference;
    },
);
